"use client";
import React from "react";
import HeroSection from "./HeroSection";
import FeatureSection from "./FeatureSection";
import DiscoverySection from "./DiscoverySection";
import CallToActionSection from "./CallToActionSection";
import FooterSection from "./FooterSection";
import ImageGallery from "./imageGallart";
import { sampleImages } from "@/lib/constants";

function Landing() {
  const targetRef = React.useRef<HTMLDivElement>(null);

  return (
    <div>
      <HeroSection scrollTargetRef={targetRef} />
      <FeatureSection />
      <DiscoverySection ref={targetRef} />
      <ImageGallery images={sampleImages} />
      <CallToActionSection />
      <FooterSection />
    </div>
  );
}

export default Landing;
